var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 633,
    height: 100,
    viewBox: "0 0 633 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "46.329%",
    cy: "60.504%",
    fx: "46.329%",
    fy: "60.504%",
    r: "101.11%",
    gradientTransform: "matrix(.1098 -.91639 .40874 .65087 .165 .636)",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93D7E9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27B0D4",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-16 -251.14 937.912)",
    d: "M248.795 105.557L857.292 280.04l-379.468-4.781-256.593-73.577z",
    fill: "url(#a)",
    fillRule: "evenodd",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderGradient);
export default __webpack_public_path__ + "static/media/HeaderGradient.58ad1e679cce0d5280723c0f441ebc74.svg";
export { ForwardRef as ReactComponent };